import React, { Component } from 'react'
import Logo from '../../assets/image/logo.png'
import './css/navbar.css'
import ClearIcon from '@material-ui/icons/Clear';
import SublistServices from './sublist_services'
import ReactGA from 'react-ga';
import {TRACKING_ID} from '../../service/base_url'
export default class index extends Component {
    state={
        show_menu:false,
        sublist_services:false,
        sublist_publication:false
    }
    componentDidMount(){
        // console.log('trigger',window.location)
        ReactGA.initialize(TRACKING_ID);
        ReactGA.pageview(window.location.href);
    }
    toggleSublist=(key)=>{
        if(key==='sublist_services'){
            this.setState({sublist_services:!this.state[key],sublist_publication:false})
        }else if(key==='sublist_publication'){
            this.setState({sublist_publication:!this.state[key],sublist_services:false})

        }else{
            this.setState({sublist_publication:false,sublist_services:false})
        }
        // this.setState({[key]:!this.state[key],})
    }
    toggleMenu=()=>{
        this.setState({show_menu:!this.state.show_menu})
    }
    renderActiveLink=(str)=>{
        let url=window.location.pathname
        let match=url.includes(str)
        if(str==='/event&webinar'&&url==='/event'){
            return '#00a1ed'
        }
        if(url==='/insight'&&str==='/publication/'){

            return '#00a1ed'
        }
        if(match){
            return '#00a1ed'
        }else{
            return '#252525'
        }
        
    }
    render() {
    // console.log('window.location.href', window.location.pathname)

        const {show_menu}=this.state
        return (
            <div >
            {/* <SublistServices/> */}
           
            <div className='sublist-publication'  style={{visibility:this.state.sublist_publication?'visible':'hidden'}}>
                <ul onMouseOver={()=>this.toggleSublist('sublist_publication')} onMouseOut={()=>this.toggleSublist()}>
                    <li><a className='a-menu' href="/publication/booklist">Book List</a></li>
                    <li><a className='a-menu' href="/publication/whitepaper">Whitepaper</a></li>
                    <li><a className='a-menu' href="/insight">Insight</a></li>
                    <li><a className='a-menu' href="/publication/bulletin">Knowledge Capital Bulletin</a></li>
                    <li><a className='a-menu' href="https://content.gmlperformance.com/catalog">E-Catalogue</a></li>
                </ul>
            </div>
            <div className='sublist-services' style={{visibility:this.state.sublist_services?'visible':'hidden'}}>
                <ul onMouseOver={()=>this.toggleSublist('sublist_services')} onMouseOut={()=>this.toggleSublist()}>
                    <li><a className='a-menu' href="/services/consulting">Strategy & Organization</a></li>
                    <li><a className='a-menu' href="/services/learning">Learning</a></li>
                    <li><a className='a-menu' href="/services/eventmanagement">Event Management</a></li>
                    <li><a className='a-menu' href="/services/assesment">Assessment Center</a></li>
                    <li><a className='a-menu' href="/services/digitallearning">Digital Learning</a></li>
                    <li><a className='a-menu' href="https://cdhx.gmlperformance.com/">Digital & Human Transformation</a></li>
                </ul>
            </div>
            <div className={show_menu?'mobile-menu':'hidden'}>
                       <div className='mobile-menu-head'>
                           <h1>MENU</h1> 
                           <h1 onClick={this.toggleMenu}><ClearIcon  style={{fontSize:40}} /></h1>
                       </div>
                       <div className='mobile-menu-list'>
                           <h6>Services</h6>
                           <h6 className="submenu"><a className='a-menu' className='a-menu' href="/services/consulting">Strategy & Organization</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="/services/learning">Learning</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="/services/eventmanagement">Event Management</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="/services/assesment">Assessment Center</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="/services/digitallearning">Digital Learning</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="https://cdhx.gmlperformance.com">Digital & Human Transformation</a></h6>


                           <h6>Publication</h6>
                           <h6 className="submenu"><a className='a-menu' href="/publication/booklist">BookList</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="/publication/whitepaper">Whitepaper</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="/insight">Insight</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="/publication/bulletin">Knowledge Capital Bulletin</a></h6>
                           <h6 className="submenu"><a className='a-menu' href="https://content.gmlperformance.com/catalog">E-Catalogue</a></h6>

                           <h6><a className='a-menu' href="https://content.gmlperformance.com/calendar" >Calendar</a></h6>
                           <h6><a className='a-menu' href="/event" >Event & Webinar</a></h6>
                           <h6><a className='a-menu' href="/careers">Careers</a></h6>
                           <h6><a className='a-menu' href="/about" >About Us</a></h6>

                       </div>
                    </div>
                <nav >
               
                    
                    <div className={show_menu?'hidden':'navbar'} >
                    <div className='logo' >
                        <img src={Logo} alt="logo" onClick={()=>window.location.assign('/')}/>
                    </div>
                    <div className='hamburger' onClick={this.toggleMenu}>
                        <div className="line"></div>
                        <div className="line-middle"></div>
                        <div className="line"></div>
                    </div>
                    <div style={{display:'flex',width:860,justifyContent:'space-around'}}>
                    <div className="service-menu">
                        <a tabIndex={1} style={{color:this.renderActiveLink('/services/')}} onMouseOver={()=>this.toggleSublist('sublist_services')} onMouseOut={()=>this.toggleSublist()} >Services</a>
                       
                    </div>
                    <div className="publication-menu">
                        <a tabIndex={2} style={{color:this.renderActiveLink('/publication/')}} onMouseOver={()=>this.toggleSublist('sublist_publication')} onMouseOut={()=>this.toggleSublist()}>Publication</a>
                       
                    </div>
                    <div className="event-menu">
                        <button onClick={()=>window.location.assign('https://content.gmlperformance.com/calendar')} style={{color:this.renderActiveLink('calendar')}}>Calendar</button>
                        
                    </div>
                    <div className="event-menu">
                        <button onClick={()=>window.location.assign('/event')} style={{color:this.renderActiveLink('/event&webinar')}}>Event & Webinar</button>
                        
                    </div>
                    <div className="carrers-menu">
                        <button  onClick={()=>window.location.assign('/careers')} style={{color:this.renderActiveLink('/careers')}}>Careers</button>
                        
                    </div>
                    <div className="about-menu">
                        <button onClick={()=>window.location.assign('/about')} style={{color:this.renderActiveLink('/about')}}>About Us</button>
                        
                    </div>
                    </div>
                    {/* <ul className="nav-links">
                        <li><a href="/services">Services</a></li>
                        <li><a href="/services">Publication</a></li>
                        <li><a href="/services">Event</a></li>
                        <li><a href="/services">Carrers</a></li>
                        <li><a href="/services">About Us</a></li>

                    </ul> */}
                    </div>
                    
                </nav>
            </div>

        )
    }
}
